import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { path: '/classification/services/categories', label: 'Categorías' },
  { path: '/classification/services/subcategories', label: 'Subcategorías' },
  { path: '/classification/services/families', label: 'Familias' },
  { path: '/classification/services/hierarchy', label: 'Vista jerárquica' },
];

const ServicesClassificationNav = () => {
  const location = useLocation();

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {LINKS.map((link) => {
        const active = location.pathname === link.path;
        return (
          <Link
            key={link.path}
            to={link.path}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              active
                ? 'bg-teal-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {link.label}
          </Link>
        );
      })}
    </div>
  );
};

export default ServicesClassificationNav;
